'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2016/9/9.
                    */

// import GoeasyRadio from '../GoeasyInputField/GoeasyRadio';

// import RadioGroup from 'react-radio';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _SubmitBtn = require('../SubmitBtn/SubmitBtn');

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _HomePagingBar = require('../HomePagingBar/HomePagingBar');

var _HomePagingBar2 = _interopRequireDefault(_HomePagingBar);

var _reactCollapse = require('react-collapse');

var _reactCollapse2 = _interopRequireDefault(_reactCollapse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderDetailComponent = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OrderDetailComponent, _Component);

  function OrderDetailComponent() {
    (0, _classCallCheck3.default)(this, OrderDetailComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderDetailComponent).call(this));

    _this.state = {
      isPolicyOpened: false,
      isServiceOpened: false,
      isPackagingOpened: false,
      isCustomOpened: false,
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(OrderDetailComponent, [{
    key: 'onConfirmReceipt',
    value: function onConfirmReceipt(orderId) {
      var confirmReceipt = this.props.confirmReceipt;

      if (confirmReceipt) {
        confirmReceipt(orderId);
      }
    }
  }, {
    key: 'onCancelOrder',
    value: function onCancelOrder(orderId) {
      var cancelOrder = this.props.cancelOrder;

      if (cancelOrder) {
        cancelOrder(orderId);
      }
    }
  }, {
    key: 'onAllModalOpen',
    value: function onAllModalOpen(productId) {
      var onDetailShow = this.props.onDetailShow;

      if (onDetailShow) {
        onDetailShow(productId);
      }
    }
  }, {
    key: 'onAllModalHide',
    value: function onAllModalHide() {
      var onDetailModalClose = this.props.onDetailModalClose;

      if (onDetailModalClose) {
        onDetailModalClose();
        this.setState({
          isPolicyOpened: false,
          isServiceOpened: false,
          isPackagingOpened: false,
          isCustomOpened: false
        });
      }
    }
  }, {
    key: 'onDetailShow',
    value: function onDetailShow(value) {
      var _state = this.state;
      var isPolicyOpened = _state.isPolicyOpened;
      var isServiceOpened = _state.isServiceOpened;
      var isPackagingOpened = _state.isPackagingOpened;
      var isCustomOpened = _state.isCustomOpened;
      /*  if (value === 'policy') {
       this.setState({
       isPolicyOpened: !isPolicyOpened
       });
       }*/

      switch (value) {
        case 'policy':
          this.setState({
            isPolicyOpened: !isPolicyOpened
          });
          break;
        case 'service':
          this.setState({
            isServiceOpened: !isServiceOpened
          });
          break;
        case 'packaging':
          this.setState({
            isPackagingOpened: !isPackagingOpened
          });
          break;
        case 'custom':
          this.setState({
            isCustomOpened: !isCustomOpened
          });
          break;
        default:
      }
    }
  }, {
    key: 'pageItemClick',
    value: function pageItemClick(page) {
      // console.log(page);
      var onPageItemClick = this.props.onPageItemClick;

      if (onPageItemClick) {
        onPageItemClick(page);
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'isEmptyObject',
    value: function isEmptyObject(element) {
      var tvar = void 0;
      for (tvar in element) {
        if (tvar) {
          return !1;
        }
      }
      return !0;
    }
  }, {
    key: 'analysisDetailModal',
    value: function analysisDetailModal() {
      var _this2 = this;

      var _props = this.props;
      var modalProductId = _props.modalProductId;
      var detailData = _props.detailData;
      var orderProductDetail = _props.orderProductDetail;
      var detailModalOpened = _props.detailModalOpened;
      var _state2 = this.state;
      var isPolicyOpened = _state2.isPolicyOpened;
      var isServiceOpened = _state2.isServiceOpened;
      var isPackagingOpened = _state2.isPackagingOpened;
      var isCustomOpened = _state2.isCustomOpened;
      var closeHover = _state2.closeHover;

      var styles = require('./OrderDetailComponent.scss');
      var allCustomStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 0px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '80rem',
          maxWidth: '80rem'
        }
      };
      // let policyModalDiv = '';
      var currentProduct = {};
      orderProductDetail.forEach(function (product) {
        if (product.id === modalProductId) {
          currentProduct = (0, _extends3.default)({}, product);
          /* if (product.policyList instanceof Array) {
           policyModalDiv = product.policyList.map((policyInfo, index)=> {
           return <GoeasyRadio key={index} Id={policyInfo.value} currentData={policyInfo}/>;
           });
           } */
        }
      });

      var packagingData = detailData.packagingData;
      var serviceData = detailData.serviceData;
      var customData = detailData.customData;

      var price = 0;
      if (!this.isEmptyObject(currentProduct)) {
        if (!isNaN(parseFloat(currentProduct.price, 10))) {
          price = parseFloat(currentProduct.price, 10).toFixed(2);
        }
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: allCustomStyle, isOpen: detailModalOpened },
        _react2.default.createElement(
          'div',
          { className: styles.modalTitle },
          _react2.default.createElement('img', { className: closeHover ? styles.xuzhuan : styles.xuzhuan_a, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return _this2.onAllModalHide();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'div',
          { style: { padding: '10px 20px 0px' } },
          _react2.default.createElement(
            'div',
            { className: styles.modalTopTitle, style: { marginTop: 10 } },
            '订单查看'
          ),
          _react2.default.createElement('div', { className: styles.line }),
          _react2.default.createElement('div', { className: styles.shortLine }),
          _react2.default.createElement(
            'table',
            { className: styles.modalComponent },
            _react2.default.createElement(
              'colgroup',
              null,
              _react2.default.createElement('col', { width: '25%' }),
              _react2.default.createElement('col', { width: '25%' }),
              _react2.default.createElement('col', { width: '25%' }),
              _react2.default.createElement('col', { width: '25%' })
            ),
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  '艺品'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '数量'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '单价'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '金额'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  currentProduct.name,
                  currentProduct.size
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  currentProduct.number
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  price
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  currentProduct.money
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.modalContent },
          _react2.default.createElement(
            'div',
            { className: styles.detailContent },
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.modalTopTitle },
              '优惠'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this2.onDetailShow('policy');
                },
                className: isPolicyOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.line }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isPolicyOpened },
              _react2.default.createElement(
                'div',
                {
                  style: { margin: '30px 0px 0px 100px', fontSize: '14px', height: 200, width: '100%' } },
                currentProduct.policy ? currentProduct.policy : '无优惠'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.modalTopTitle },
              '服务'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this2.onDetailShow('service');
                },
                className: isServiceOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            serviceData instanceof Array ? _react2.default.createElement(
              'div',
              { className: styles.modalTopMoney },
              _react2.default.createElement(
                'span',
                null,
                '金额：'
              ),
              _react2.default.createElement(
                'span',
                null,
                serviceData[0].money
              )
            ) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.line }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isServiceOpened },
              _react2.default.createElement(
                'table',
                { className: styles.modalTableComponent },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '50%' }),
                  _react2.default.createElement('col', { width: '50%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      '项目'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '单价'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  serviceData instanceof Array ? serviceData.map(function (serviceInfo, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index, className: styles.item },
                      _react2.default.createElement(
                        'td',
                        null,
                        serviceInfo.project
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        serviceInfo.price
                      )
                    );
                  }) : ''
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.modalTopTitle },
              '包装'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this2.onDetailShow('packaging');
                },
                className: isPackagingOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            packagingData instanceof Array ? _react2.default.createElement(
              'div',
              { className: styles.modalTopMoney },
              _react2.default.createElement(
                'span',
                null,
                '金额：'
              ),
              _react2.default.createElement(
                'span',
                null,
                packagingData[0].money
              )
            ) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.line }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isPackagingOpened },
              _react2.default.createElement(
                'table',
                { className: styles.modalTableComponent },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('th', null),
                    _react2.default.createElement(
                      'th',
                      null,
                      '项目'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '内容'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '单价'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  packagingData instanceof Array ? packagingData.map(function (packagingInfo, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index, className: styles.item },
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.img ? _react2.default.createElement('img', { className: styles.dingzImg, src: packagingInfo.img }) : ''
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.project
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.content
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        packagingInfo.price
                      )
                    );
                  }) : ''
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: 'left' }, className: styles.modalTopTitle },
              '定制'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.pateTopTail },
              _react2.default.createElement('img', { onClick: function onClick() {
                  return _this2.onDetailShow('custom');
                },
                className: isCustomOpened ? styles.zhuan : styles.zhuan_a,
                src: 'http://tupian.goeasy.cn:9999/yipinwang/third/sletxia.png' })
            ),
            customData instanceof Array ? _react2.default.createElement(
              'div',
              { className: styles.modalTopMoney },
              _react2.default.createElement(
                'span',
                null,
                '金额：'
              ),
              _react2.default.createElement(
                'span',
                null,
                customData[0].money
              )
            ) : '',
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement('div', { className: styles.line }),
            _react2.default.createElement('div', { className: styles.shortLine }),
            _react2.default.createElement(
              _reactCollapse2.default,
              { isOpened: isCustomOpened },
              _react2.default.createElement(
                'table',
                { className: styles.modalTableComponent },
                _react2.default.createElement(
                  'colgroup',
                  null,
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' }),
                  _react2.default.createElement('col', { width: '25%' })
                ),
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('th', null),
                    _react2.default.createElement(
                      'th',
                      null,
                      '项目'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '内容'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '单价'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  customData instanceof Array ? customData.map(function (customInfo, index) {
                    return _react2.default.createElement(
                      'tr',
                      { key: index, className: styles.item },
                      _react2.default.createElement(
                        'td',
                        null,
                        _react2.default.createElement('img', { className: styles.dingzImg, src: customInfo.img })
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        customInfo.project
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        customInfo.content
                      ),
                      _react2.default.createElement(
                        'td',
                        null,
                        customInfo.price
                      )
                    );
                  }) : ''
                )
              )
            ),
            _react2.default.createElement('div', { style: { width: '100%', height: 100 } })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.modalContent },
          _react2.default.createElement('div', { className: styles.line, style: { marginTop: 20 } }),
          _react2.default.createElement(
            'div',
            { className: styles.detailContent },
            _react2.default.createElement(
              'table',
              { className: styles.modalTableComponent },
              _react2.default.createElement(
                'colgroup',
                null,
                _react2.default.createElement('col', { width: '25%' }),
                _react2.default.createElement('col', { width: '25%' }),
                _react2.default.createElement('col', { width: '25%' }),
                _react2.default.createElement('col', { width: '25%' })
              ),
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    '艺品金额'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '购买金额'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '优惠金额'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '结算金额'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.money
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.buyMoney
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.discount
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: styles.item },
                    currentProduct.sumMoney
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_SubmitBtn2.default, { btnClick: function btnClick() {
            return _this2.onAllModalHide();
          }, text: '关闭' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./OrderDetailComponent.scss');
      var _props2 = this.props;
      var orderDetail = _props2.orderDetail;
      var orderLogisticsInformation = _props2.orderLogisticsInformation;
      var orderProductDetail = _props2.orderProductDetail;
      var totalPageNumber = _props2.totalPageNumber;

      var returnDiv = _react2.default.createElement('div', null);
      var payPlatformImg = '';
      if (orderDetail instanceof Array && orderDetail.length > 0) {
        (function () {
          var currentOrderDetail = orderDetail[0];
          switch (currentOrderDetail.payPlatform) {
            case 'M0042510000000000000000001':
              payPlatformImg = 'http://tupian.goeasy.cn:9999/yipinwang/third/weixinpay.png';
              break;
            case 'M0042510000000000000000002':
              payPlatformImg = 'http://tupian.goeasy.cn:9999/yipinwang/third/alipaylittle.png';
              break;
            default:
              payPlatformImg = '';
              break;
          }
          var productsDetailShow = '';
          if (orderProductDetail instanceof Array) {
            productsDetailShow = orderProductDetail.map(function (product, outIndex) {
              var buyPrice = 0;
              if (!isNaN(parseFloat(product.buyPrice, 10))) {
                buyPrice = parseFloat(product.buyPrice, 10).toFixed(2);
              }
              return _react2.default.createElement(
                'tr',
                { key: outIndex },
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: (product.isCustomProduct && product.isCustomProduct === '1' ? '/customproduct/' : '/product/') + product.productId,
                      target: '_blank' },
                    _react2.default.createElement('img', {
                      className: styles.productImg, src: product.img, alt: '' })
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  product.name,
                  product.size
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  buyPrice,
                  _react2.default.createElement('span', null)
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  _react2.default.createElement(
                    'span',
                    null,
                    product.number
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  _react2.default.createElement(
                    'span',
                    null,
                    product.sumMoney
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: styles.item },
                  _react2.default.createElement(
                    'span',
                    { onClick: function onClick() {
                        return _this3.onAllModalOpen(product.id);
                      },
                      className: styles.button },
                    '详情查询'
                  )
                )
              );
            });
          }
          returnDiv = _react2.default.createElement(
            'div',
            { className: styles.newPagedd },
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle },
              '订单信息'
            ),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'ul',
              { className: styles.pageDdul },
              orderLogisticsInformation && orderLogisticsInformation instanceof Array ? orderLogisticsInformation.map(function (logistics, index) {
                return _react2.default.createElement(
                  'li',
                  { style: { background: index % 2 === 0 ? '#efefef' : '' } },
                  _react2.default.createElement(
                    'div',
                    { className: styles.txt1 },
                    logistics.date
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.txt2 },
                    logistics.message
                  )
                );
              }) : ''
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle, style: { marginTop: '48px' } },
              '配送方式'
            ),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement(
              'div',
              { className: styles.pageDdCon },
              _react2.default.createElement(
                'div',
                { className: styles.ddConBox },
                _react2.default.createElement(
                  'div',
                  { className: styles.ddConBoxTxt },
                  '配送地址：',
                  currentOrderDetail.address
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.ddConBox },
                _react2.default.createElement(
                  'div',
                  { className: styles.ddConBoxTxt },
                  '配送方式：',
                  currentOrderDetail.distributionMethods
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.ddConName },
                _react2.default.createElement(
                  'div',
                  { className: styles.ddConNameTxt, style: { marginLeft: '40px' } },
                  currentOrderDetail.receiver
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.ddConNameTxt },
                  currentOrderDetail.receiverPhone
                )
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle, style: { marginTop: '15px' } },
              '艺品清单'
            ),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement(
              'div',
              { className: styles.pageQingdan },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'table',
                  { className: styles.table },
                  _react2.default.createElement(
                    'colgroup',
                    null,
                    _react2.default.createElement('col', { width: '20%' }),
                    _react2.default.createElement('col', { width: '24%' }),
                    _react2.default.createElement('col', { width: '15%' }),
                    _react2.default.createElement('col', { width: '18%' }),
                    _react2.default.createElement('col', { width: '16%' }),
                    _react2.default.createElement('col', { width: '16%' })
                  ),
                  _react2.default.createElement(
                    'thead',
                    null,
                    _react2.default.createElement(
                      'tr',
                      null,
                      _react2.default.createElement(
                        'th',
                        null,
                        '图片'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '艺品'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '单价'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '数量'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        '金额'
                      ),
                      _react2.default.createElement(
                        'th',
                        null,
                        ' '
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'tbody',
                    null,
                    productsDetailShow
                  )
                ),

                // selected={currentPage}
                totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_HomePagingBar2.default, { totalPageNumber: totalPageNumber,
                  onPageItemClick: _this3.pageItemClick.bind(_this3) }) : ''
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle, style: { marginTop: '36px' } },
              '付款方式'
            ),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement(
              'div',
              { className: styles.fukuanIdea },
              _react2.default.createElement(
                'div',
                { className: styles.paymentType },
                currentOrderDetail.paymentType
              ),
              _react2.default.createElement(
                'div',
                { className: styles.ideaTitle },
                currentOrderDetail.statusId === '000011' ? '待支付金额' : '支付金额',
                ' ',
                _react2.default.createElement('input', {
                  type: 'text', value: currentOrderDetail.money,
                  readOnly: true }),
                ' 元'
              ),
              currentOrderDetail.statusId === '000011' ? '' : _react2.default.createElement('img', { className: styles.ideaPicture, src: payPlatformImg })
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.pageTopTitle, style: { marginTop: '45px' } },
              '发票信息'
            ),
            _react2.default.createElement('div', { className: styles.linka }),
            _react2.default.createElement(
              'div',
              { className: styles.voiceLeH1 },
              '发票类型：',
              currentOrderDetail.invoiceType
            ),
            _react2.default.createElement(
              'div',
              { className: styles.voiceRiH2 },
              _react2.default.createElement(
                'span',
                null,
                '发票内容：',
                currentOrderDetail.invoiceTitle
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'span',
                {
                  style: { fontSize: '18px' } },
                currentOrderDetail.invoiceContent
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/orderlist', className: styles.tuichuBtn },
              '退出查询'
            ),
            currentOrderDetail.statusId === '000011' || currentOrderDetail.statusId === '000012' || currentOrderDetail.statusId === '000018' || currentOrderDetail.statusId === '000019' ? _react2.default.createElement(
              'span',
              { style: { marginRight: 20 }, onClick: function onClick() {
                  return _this3.onCancelOrder(currentOrderDetail.id);
                },
                className: styles.tuichuBtn },
              '取消订单'
            ) : '',
            currentOrderDetail.statusId === '000011' ? _react2.default.createElement(
              _reactRouter.Link,
              { style: { marginRight: 20 },
                to: '/payment/' + currentOrderDetail.payNumber + '/' + currentOrderDetail.activeId,
                className: styles.tuichuBtn },
              '去支付'
            ) : '',
            currentOrderDetail.statusId === '000015' ? _react2.default.createElement(
              'span',
              { style: { marginRight: 20 }, onClick: function onClick() {
                  return _this3.onConfirmReceipt(currentOrderDetail.id);
                },
                className: styles.tuichuBtn },
              '确认收货'
            ) : '',
            _this3.analysisDetailModal()
          );
        })();
      }
      return returnDiv;
    }
  }]);
  return OrderDetailComponent;
}(_react.Component), _class.propTypes = {
  orderDetail: _react.PropTypes.array,
  orderLogisticsInformation: _react.PropTypes.array,
  orderProductDetail: _react.PropTypes.array,
  detailData: _react.PropTypes.object,
  modalProductId: _react.PropTypes.string,
  detailModalOpened: _react.PropTypes.bool,
  onDetailShow: _react.PropTypes.func,
  onDetailModalClose: _react.PropTypes.func,
  cancelOrder: _react.PropTypes.func,
  confirmReceipt: _react.PropTypes.func,
  onPageItemClick: _react.PropTypes.func,
  // currentPage: PropTypes.number,
  totalPageNumber: _react.PropTypes.number
}, _temp);
exports.default = OrderDetailComponent;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderDetailComponent/OrderDetailComponent.js
 ** module id = 1382
 ** module chunks = 0
 **/